// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgBlockUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.88636 4C11.1081 4 12.9091 5.80104 12.9091 8.02273C12.9091 10.2444 11.1081 12.0455 8.88636 12.0455C6.66467 12.0455 4.86364 10.2444 4.86364 8.02273C4.86364 5.80104 6.66467 4 8.88636 4ZM8.88636 5.5C7.4931 5.5 6.36364 6.62946 6.36364 8.02273C6.36364 9.41599 7.4931 10.5455 8.88636 10.5455C10.2796 10.5455 11.4091 9.41599 11.4091 8.02273C11.4091 6.62946 10.2796 5.5 8.88636 5.5ZM11.75 13C13.9717 13 15.7727 14.801 15.7727 17.0227V18.6591C15.7727 19.0733 15.4369 19.4091 15.0227 19.4091H2.75C2.33579 19.4091 2 19.0733 2 18.6591V17.0227C2 14.801 3.80104 13 6.02273 13H11.75ZM11.9159 14.5054L11.75 14.5H6.02273C4.62946 14.5 3.5 15.6295 3.5 17.0227V17.909H14.272L14.2727 17.0227C14.2727 15.6852 13.2318 14.5908 11.9159 14.5054Z"
					fill="#2E2F32"
				/>
				<g clipPath="url(#clip0_4519_296727)">
					<path
						d="M17.9971 6C15.2441 6 13 8.24407 13 10.9971C13 13.7501 15.2441 15.9942 17.9971 15.9942C20.7501 15.9942 22.9942 13.7501 22.9942 10.9971C22.9942 8.24407 20.7559 6 17.9971 6ZM17.9971 7.73511C18.5813 7.73511 19.1307 7.89127 19.605 8.1631L15.1573 12.6108C14.8855 12.1365 14.7293 11.587 14.7293 11.0029C14.7293 9.20416 16.1926 7.74089 17.9913 7.74089L17.9971 7.73511ZM17.9971 14.2649C17.413 14.2649 16.8635 14.1087 16.3892 13.8369L20.8369 9.38924C21.1087 9.8635 21.2649 10.413 21.2649 10.9971C21.2649 12.7958 19.8016 14.2591 18.0029 14.2591L17.9971 14.2649Z"
						fill="#EF6C16"
					/>
				</g>
				<defs>
					<clipPath id="clip0_4519_296727">
						<rect width={10} height={10} fill="white" transform="translate(13 6)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgBlockUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgBlockUnique24;
